import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StudioPage from "../pages/studio/page";
import ContactPage from "../pages/contact/page";
import ServicesPage from "../pages/services/page";
import ProductsPage from "../pages/products/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import RefundPage from "../pages/refund/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <StudioPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/refund", element: <RefundPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;